import { Mono, Text } from '@/components/ui/Text';
import { colors, progressRing } from '@/theme/tokens';
import styles from './ProgressRing.module.css';

interface ProgressRingProps {
  /** 0–1. */
  value: number;
  size?: number;
  label?: string;
}

/**
 * The hero's collection-progress ring.
 *
 * The handoff specifies a `conic-gradient`. React Native has none, so the mobile
 * app approximated it with a stroked SVG circle and a dash offset; this is the
 * specified value itself. Do not reintroduce the SVG.
 */
export function ProgressRing({ value, size = 66, label = 'ທວງແລ້ວ' }: ProgressRingProps) {
  const clamped = Math.max(0, Math.min(1, value));
  const pct = Math.round(clamped * 100);
  const inner = 50;

  return (
    <div
      className={styles.ring}
      style={{ width: size, height: size, background: progressRing(pct) }}
      role="img"
      aria-label={`${label} ${pct}%`}
    >
      <div className={styles.disc} style={{ width: inner, height: inner }}>
        <Mono weight={700} size={14} color="#FFFFFF">
          {pct}%
        </Mono>
        <Text size={8} color={colors.onDarkSoft}>
          {label}
        </Text>
      </div>
    </div>
  );
}
